<ea-modal modalId="sessionTimeout" title="Your session is about to expire!">
	<ng-template #modalBody>
		<ea-paragraph>
			<div class="session-timeout-message">
				<span
					>You will be logged out in
					{{ countdown | secondsToMinutesSeconds }}</span
				>
				@if (countdown >= 60) {
					<span>
						{{ countdown | i18nPlural: minuteOrGreaterPluralMapping }}
					</span>
				}
				@if (countdown < 60) {
					<span>
						{{ countdown | i18nPlural: lessThanMinutePluralMapping }}
					</span>
				}
				<span
					>If you would like to continue your session, please move your
					mouse.</span
				>
			</div>
		</ea-paragraph>
	</ng-template>
</ea-modal>
